var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Theme'),(_vm.$store.state.ie.sigla === 'ebr')?_c('ThemeEBRADI'):_vm._e(),_c('ThemeCheckout'),_c('transition',{attrs:{"name":"scale"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }